import { getPalette } from 'owa-theme';
import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';

const RIGHT_PADDING = 8;

const styles = require('./NotificationBar.scss');

export const actionButtonStyles: IButtonStyles = {
    root: {
        backgroundColor: getPalette().neutralSecondary,
        marginRight: RIGHT_PADDING + 'px',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: getPalette().white,
    },
    rootHovered: {
        backgroundColor: getPalette().neutralPrimaryAlt,
    },
    rootPressed: {
        backgroundColor: getPalette().neutralDark,
    },
    textContainer: {
        overflow: 'hidden',
    },
    label: styles.actionButtonText,
};

export const dismissButtonStyles: IButtonStyles = {
    root: {
        marginRight: RIGHT_PADDING + 'px',
        color: getPalette().white,
    },
    rootHovered: {
        color: getPalette().white,
        backgroundColor: 'transparent',
    },
    rootPressed: {
        color: getPalette().neutralDark,
        backgroundColor: 'transparent',
    },
};
